import { Injectable, NgZone } from "@angular/core";
import { TranslocoService } from "@ngneat/transloco";
import { Message, MessageService } from "primeng/api";

@Injectable({
    providedIn: 'root'
})
//Service to wrap message service by primeNG
export class ToastService {
    constructor(
        private messageService: MessageService,
        private translocoService: TranslocoService,
        private ngZone: NgZone
    ) { }

    genericError(details?: string) {
        // this.messageService.clear();
        this.ngZone.run(() => {
            this.add({
                severity: 'error',
                summary: 'errorMsg.generic',
                detail: details ? details : 'errorMsg.tryAgain',
            })
        });
    }

    add(message: Message): void {
        if (message.detail && message.data?.message) message.detail = this.translocoService.translate(message.detail, message.data.message)
        if (message.detail && !message.data?.message) message.detail = this.translocoService.translate(message.detail);
        if (message.summary) message.summary = this.translocoService.translate(message.summary);
        if (!message.key) message.key = 'toast';
        this.ngZone.run(() => {
            this.messageService.add(message);
        });
    }

    addAll(messages: Message[]): void {
        messages.map(message => {
            if (message.detail) message.detail = this.translocoService.translate(message.detail)
            if (message.summary) message.summary = this.translocoService.translate(message.summary)
            if (!message.key) message.key = 'toast';
            return message;
        });
        this.ngZone.run(() => {
            this.messageService.addAll(messages);
        });
    }

    clear(key: string = 'toast'): void {
        this.messageService.clear(key);
    }

    sessionExpired() {
        this.add({
            key: 'session-expired',
            severity: 'error',
            summary: 'errorMsg.sessionExpired',
            detail: 'toastMessage.loginAgain',
            sticky: true
        });
        setInterval(() => {
            location.reload();
        }, 5000);
    }

}